import { render, staticRenderFns } from "./AvatarLink.vue?vue&type=template&id=6da325f2&"
import script from "./AvatarLink.vue?vue&type=script&lang=js&"
export * from "./AvatarLink.vue?vue&type=script&lang=js&"
import style0 from "./AvatarLink.vue?vue&type=style&index=0&id=6da325f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports